<template>
  <QField
    v-bind="$attrs"
    :class="[
      'sai-input',
      { 'sai-input--large': large, 'sai-input--extra-large': extraLarge }
    ]"
    :hide-bottom-space="hideBottomSpace"
    :rounded="rounded"
    borderless
    :error="error"
    no-error-icon
  >
    <input
      v-on="boundListeners"
      :class="[
        `q-field__native q-placeholder text-${error ? 'negative' : textColor}`,
        { 'text-center': textCenter }
      ]"
      :value="value"
      v-money="vMoney"
      @input="updateInput"
    />
  </QField>
</template>

<script>
import { QField } from 'quasar';
import { VMoney } from 'v-money';

export default {
  name: 'SAICurrencyInput',
  props: {
    value: undefined,
    precision: {
      type: Number,
      default: 0
    },
    prefix: {
      type: String,
      default: '$'
    },
    suffix: {
      type: String,
      default: undefined
    },
    decimalSeparator: {
      type: String,
      default: '.'
    },
    thousandsSeparator: {
      type: String,
      default: ','
    },
    large: Boolean,
    extraLarge: {
      type: Boolean,
      default: true
    },
    hideBottomSpace: {
      default: true
    },
    rounded: {
      type: Boolean,
      default: true
    },
    textCenter: {
      type: Boolean,
      default: true
    },
    textColor: {
      type: String,
      default: 'primary'
    },
    error: Boolean
  },
  computed: {
    vMoney() {
      return {
        prefix: this.prefix,
        suffix: this.suffix,
        decimal: this.decimalSeparator,
        thousands: this.thousandsSeparator,
        precision: this.precision
      };
    },
    boundListeners() {
      // Exclude the input listener as it has a custom handler through updateInput
      const { input, ...rest } = this.$listeners;
      return rest;
    }
  },
  methods: {
    updateInput(event) {
      let value = event.target.value;
      let regex = new RegExp(`[.,${this.suffix}${this.prefix}]+`, 'g');
      value = value.replace(regex, '');
      value = this.precision ? parseFloat(value) : parseInt(value);
      if (value !== this.value) {
        this.$emit('input', value);
      }
    }
  },
  components: {
    QField
  },
  directives: { money: VMoney }
};
</script>
